var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClusteringOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.374,
    height: 15.179,
    viewBox: "0 0 13.374 15.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_clustering_on",
    d: "M-8587.828-3417.785a3.254,3.254,0,0,1,3.254-3.255,3.254,3.254,0,0,1,3.255,3.255,3.254,3.254,0,0,1-3.255,3.252A3.254,3.254,0,0,1-8587.828-3417.785Zm-6.076-3.82a3.2,3.2,0,0,1,3.2-3.2,3.2,3.2,0,0,1,3.2,3.2,3.2,3.2,0,0,1-3.2,3.2A3.2,3.2,0,0,1-8593.9-3421.6Zm10.14-1.391a1.617,1.617,0,0,1,1.617-1.617,1.617,1.617,0,0,1,1.617,1.617,1.618,1.618,0,0,1-1.617,1.618A1.618,1.618,0,0,1-8583.765-3423Zm-5.436-3.763a2.953,2.953,0,0,1,2.953-2.953,2.953,2.953,0,0,1,2.952,2.953,2.953,2.953,0,0,1-2.952,2.955A2.953,2.953,0,0,1-8589.2-3426.759Z",
    transform: "translate(8593.904 3429.712)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClusteringOn);
export default __webpack_public_path__ + "static/media/icon_clustering_on.d112609b.svg";
export { ForwardRef as ReactComponent };